import api from 'lib/trpcClient';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';

function useChangeApplicationTranche() {
  return api.incompleteInvestment.changeTranche.useMutation(
    useHandleTrpcMutation()({
      successMessage: 'Tranche updated successfully.',
    }),
  );
}

export default useChangeApplicationTranche;
